<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title" #title (click)="onTitleClick()">Campaign Incentive Sets</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list-header color="secondary" class="ion-text-wrap">
        {{incentiveSets.length}} Incentive sets defined.
    </ion-list-header>

    <ion-list class="ion-padding">
        @for (set of incentiveSets; track $index) {
  <ion-item-sliding>
            <ion-item data-test="incentiveSet" (click)="onIncentiveSetClick(set)" detail="true" href="javascript:;">
                <ion-label>
                    <span class="line1">{{set.setName}}</span><br />
                </ion-label>
            </ion-item>
            <ion-item-options>
                <ion-button data-test="deleteIncentiveSet" id="deleteIncentiveSet" color="danger" (click)="confirmDeleteIncentiveSet(set)">
                    <ion-icon name="trash"></ion-icon>
                    Delete
                </ion-button>
            </ion-item-options>
        </ion-item-sliding>
}
    </ion-list>

</ion-content>

<ion-footer>
    <ion-fab vertical="bottom" horizontal="end">
        <ion-fab-button [disabled]=vb.disabled id="addIncentiveSet" title="Add" (click)="onAddIncentiveSetClick()"
                        data-test="addIncentiveSetBtn">
            <ion-icon name="add"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-footer>